<template>
  <path
    d="M5 9.00024H19C19.55 9.00024 20 9.45024 20 10.0002C20 10.5502 19.55 11.0002 19 11.0002H5C4.45 11.0002 4 10.5502 4 10.0002C4 9.45024 4.45 9.00024 5 9.00024ZM5 13.0002H13C13.55 13.0002 14 13.4502 14 14.0002C14 14.5502 13.55 15.0002 13 15.0002H5C4.45 15.0002 4 14.5502 4 14.0002C4 13.4502 4.45 13.0002 5 13.0002Z"
  />
</template>
